import { Store } from 'vuex';
import { Context } from 'vuex-smart-module';
import ClientsStore from '../../store';
import ClientsState from '../../store/state';

export default class ClientsSharedState {}
